import findDuplicates from 'utils/findDuplicates';

export default function hasDuplicates<T = string>(values: T[]): boolean {
  return findDuplicates(values).length > 0;
}
